/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import type { SearchResultItem } from '../../api/search/search.types';

export function getCardRating(item: SearchResultItem) {
    if (!item.average_rating || !item.number_of_ratings) {
        return {
            averageRating: undefined,
            reviewCount: undefined,
            ratingAriaLabel: undefined,
        };
    }

    const reviewFormatter = new Intl.NumberFormat('en-US', {
        maximumFractionDigits: 1,
        minimumFractionDigits: 1,
    });

    const reviewCountFormatter = new Intl.NumberFormat('en-US', {
        maximumFractionDigits: 0,
    });

    const averageRating = reviewFormatter.format(item.average_rating);
    const reviewCount = reviewCountFormatter.format(item.number_of_ratings);
    const ratingAriaLabel = `Rating:${averageRating} out of 5 stars ${item.number_of_ratings ? ` based on ${reviewCount} reviews.` : ''}`;
    const ratingAriaLabelShort = `${averageRating} stars`;

    return { averageRating, reviewCount, ratingAriaLabel, ratingAriaLabelShort };
}
